import { addTranslations } from '@fs/zion-locale'
import SubNav from './SubNav'
import translations from './locales'

addTranslations(translations)

export default SubNav
